(function () {
  'use strict';
  var language = (document.documentElement.lang || '').toLowerCase();
  var words = language.indexOf('en') === 0
    ? {more: 'Load more', loading: 'Loading products…', error: 'Unable to load more products. Please try again.', retry: 'Try again'}
    : /zh-(hans|cn)/.test(language)
      ? {more: '载入更多', loading: '正在载入商品…', error: '未能载入更多商品，请重试。', retry: '重试'}
      : {more: '載入更多', loading: '正在載入商品…', error: '未能載入更多商品，請重試。', retry: '重試'};
  function cards(grid) {
    return Array.from(grid.children).filter(function (e) {
      return e.classList.contains('product-block') && !e.classList.contains('product-block--flex-spacer');
    });
  }
  function initialize() {
    var grid = document.querySelector('#collection .product-list.product-grid, .csw-search-grid');
    if (!grid || grid.dataset.cswInfiniteBound) return;
    var collection = !grid.classList.contains('csw-search-grid');
    var nav = document.querySelector(collection ? '.csw-pag-links' : '.csw-search-pagination');
    if (!nav) return;
    var custom = collection && grid.dataset.cswNativePagination !== 'true';
    var next = custom ? null : nav.querySelector('a.next');
    var button = custom ? document.querySelector('.csw-load-more') : document.createElement('button');
    if (!button) { button = document.createElement('button'); button.type = 'button'; button.hidden = true; nav.after(button); }
    grid.dataset.cswInfiniteBound = 'true';
    if (!custom) {
      if (collection) { var legacy = document.querySelector('.csw-load-more'); if (legacy) legacy.remove(); }
      button.hidden = !next;
      button.type = 'button'; button.className = 'button csw-search-more'; button.textContent = words.more;
      nav.after(button);
    }
    button.style.display = 'none';
    var sentinel = document.createElement('div'); sentinel.style.height = '1px'; sentinel.setAttribute('aria-hidden', 'true'); button.after(sentinel);
    var status = document.createElement('p');
    status.className = 'csw-infinite-status'; status.setAttribute('role', 'status'); status.setAttribute('aria-live', 'polite');
    button.after(status);
    var busy = false, failed = false, restoring = false, scheduled = false;
    var guide = document.getElementById('csw-collection-guide');
    var readingGuide = !!guide && location.hash === '#csw-collection-guide', manualScroll = false;
    function showGuide() {
      if (readingGuide && guide) requestAnimationFrame(function () { guide.scrollIntoView({block: 'start', behavior: 'instant'}); });
    }
    if (guide) {
      document.querySelectorAll('.csw-guide-link[href="#csw-collection-guide"]').forEach(function (link) {
        link.addEventListener('click', function (event) {
          event.preventDefault(); event.stopPropagation(); readingGuide = true; manualScroll = false; showGuide();
        });
      });
      ['wheel', 'touchmove', 'keydown'].forEach(function (type) {
        window.addEventListener(type, function () { manualScroll = true; }, {passive: true});
      });
    }
    var loaded = [], nextURL = next ? next.href : null, requested = new Set();
    var startURL = location.href;
    function key() { return 'csw-infinite-v2:' + location.href; }
    function save() {
      try { sessionStorage.setItem(key(), JSON.stringify({y: window.scrollY, pages: loaded, shown: Number(grid.dataset.cswShown) || 0, time: Date.now()})); } catch (e) {}
    }
    var saved = null;
    try {
      var navigation = performance.getEntriesByType('navigation')[0];
      if (navigation && /^(back_forward|reload)$/.test(navigation.type)) saved = JSON.parse(sessionStorage.getItem(key()) || 'null');
      if (saved && (!Number.isFinite(saved.y) || saved.y < 0 || Date.now() - saved.time > 1800000)) saved = null;
    } catch (e) {}
    function restoreScroll() {
      if (!saved) return;
      var y = saved.y; saved = null;
      requestAnimationFrame(function () { requestAnimationFrame(function () { window.scrollTo(0, y); check(); }); });
    }
    function nearEnd() {
      return !button.hidden && sentinel.getBoundingClientRect().top < window.innerHeight + 500;
    }
    function check() {
      if (readingGuide || scheduled || restoring || busy || failed || button.hidden || button.disabled) return;
      if (custom && grid.dataset.cswJs !== 'ready') return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        if (!readingGuide && !restoring && !busy && !failed && !button.hidden && !button.disabled && nearEnd()) button.click();
      });
    }
    async function searchPage() {
      if (busy || !nextURL) return false;
      var url = new URL(nextURL, startURL), base = new URL(startURL);
      if (url.origin !== base.origin || url.pathname !== base.pathname || requested.has(url.href)) return false;
      busy = true; failed = false; button.disabled = true; status.textContent = words.loading;
      grid.setAttribute('aria-busy', 'true');
      var controller = new AbortController(), timeout = setTimeout(function () { controller.abort(); }, 15000);
      try {
        var response = await fetch(url.href, {credentials: 'same-origin', signal: controller.signal});
        if (!response.ok) throw new Error('pagination');
        var doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        var incoming = doc.querySelector(collection ? '#collection .product-list.product-grid' : '.csw-search-grid'), incomingNav = doc.querySelector(collection ? '.csw-pag-links' : '.csw-search-pagination');
        if (!incoming || !cards(incoming).length) throw new Error('grid');
        var seen = new Set(cards(grid).map(function (e) { return e.querySelector('a[href]').getAttribute('href').split('?')[0]; }));
        var fragment = document.createDocumentFragment();
        cards(incoming).forEach(function (e) {
          var link = e.querySelector('a[href]'); if (!link) return;
          var id = link.getAttribute('href').split('?')[0]; if (seen.has(id)) return;
          seen.add(id); fragment.appendChild(document.importNode(e, true));
        });
        grid.insertBefore(fragment, grid.querySelector('.product-block--flex-spacer'));
        requested.add(url.href); loaded.push(url.href);
        var link = incomingNav && incomingNav.querySelector('a.next'); nextURL = link ? link.href : null;
        if (nextURL) nextURL = new URL(link.getAttribute('href'), url.href).href;
        button.hidden = !nextURL; button.style.display = 'none'; button.textContent = words.more; nav.hidden = true; status.textContent = '';
        if (window.theme && window.theme.loadProductGrid) window.theme.loadProductGrid(grid);
        window.dispatchEvent(new Event('resize'));
        return true;
      } catch (e) {
        failed = true; status.textContent = words.error; button.textContent = words.retry; button.style.display = ''; nav.hidden = false;
        return false;
      } finally {
        clearTimeout(timeout); busy = false; button.disabled = false; grid.removeAttribute('aria-busy');
        if (!restoring) check();
      }
    }
    if (custom) {
      function sync() {
        var state = grid.dataset.cswJs;
        failed = state === 'error';
        nav.hidden = state === 'ready' || state === 'loading';
        button.style.display = failed ? '' : 'none';
        if (state === 'ready') {
          status.textContent = '';
          if (readingGuide) { saved = null; restoring = false; showGuide(); return; }
          if (saved && Number(grid.dataset.cswShown) < saved.shown && !button.hidden) { restoring = true; button.click(); return; }
          restoring = false; restoreScroll(); check();
        }
        if (state === 'loading') status.textContent = words.loading;
        if (failed) { restoring = false; status.textContent = words.error; button.textContent = words.retry; }
      }
      new MutationObserver(sync).observe(grid, {attributes: true, attributeFilter: ['data-csw-js', 'data-csw-shown']});
      sync();
    } else {
      nav.hidden = true;
      button.addEventListener('click', function () { searchPage(); });
    }
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) check();
      }, {rootMargin: '500px 0px'});
      observer.observe(sentinel);
    }
    window.addEventListener('scroll', function () {
      if (readingGuide && manualScroll && guide.getBoundingClientRect().top > window.innerHeight) readingGuide = false;
      check();
    }, {passive: true});
    window.addEventListener('resize', check, {passive: true});
    window.addEventListener('pagehide', save);
    if (!custom) {
      (async function () {
        restoring = true;
        if (saved && Array.isArray(saved.pages)) {
          for (var i = 0; i < saved.pages.length; i++) {
            if (new URL(nextURL || startURL, startURL).href !== saved.pages[i] || !(await searchPage())) break;
          }
        }
        restoring = false; restoreScroll(); check();
      })();
    }
  }
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
